// extracted by mini-css-extract-plugin
export var addressInformationBubbleContainer = "_oe-0";
export var buttonContainer = "_oe-3";
export var cancelButton = "_oe-4";
export var headerSection = "_oe-6";
export var headerTitle = "_oe-9";
export var messageSideLeft = "_oe-1";
export var messageSideRight = "_oe-2";
export var orderNumberContainer = "_oe-7";
export var orderNumberLabel = "_oe-8";
export var submitButton = "_oe-5";